import React from 'react';
import { billingV2Styles } from '../BillingV2Style';
import {useSelector} from "react-redux";
import Utils from "../../../helpers/Utils";
import TrialNotification from "./TrialNotification";

const PRICING_TYPE_MONTHLY_LABEL = 'Month';
const PRICING_TYPE_YEARLY_LABEL = 'Year';

const PRICING_ID_PRICING_TYPE_MAPPING = {
    1: PRICING_TYPE_MONTHLY_LABEL,
    2: PRICING_TYPE_YEARLY_LABEL
};

const CurrentSubscription = () => {
    const classes = billingV2Styles();
    const { userPackage, userSettings, totalCredits, isTrial} = useSelector((state) => (state.billingReducer));

    const renderBillingDate = () => {
        if (userSettings?.recurrent === '1'){
            return `Next billing date: ${Utils.formatDate(userPackage?.expire_date, 'MM/DD/YYYY')}`;
        }
        return `Subscription ends on: ${Utils.formatDate(userPackage?.expire_date, 'MM/DD/YYYY')}`;
    };

    const renderPricingTypeLabel = () => {
        if (!userPackage?.price){
            return null;
        }
        if (userPackage?.pricing_id === 3){
            try{
                const pricing = JSON.parse(userPackage?.package?.pricing);
                const userPricing = pricing.find((price) => (price.id === 3));

                if (userPricing){
                    return `Per ${userPricing.validity} days`;
                }
            }catch (err){
                return 'Error occurred!';
            }
        }else {
            return `Per ${PRICING_ID_PRICING_TYPE_MAPPING[userPackage?.pricing_id]}`;
        }
    };

    return (
        <div className={classes.currentSubscriptionWrapper}>
            <div className='headerSection'>
                <div className='headerLeft'>
                    <h5 className='title'>Current Subscription</h5>
                    <span style={{ color: "#3e50f7" }}>{userPackage?.package?.name}</span>
                </div>

                <div className='headerRight'>
                    <h2 style={{ margin: 0, color: "#3e50f7" }}>${Utils.fixDecimal(userPackage?.price)}</h2>
                    <span className='perMonth'>{renderPricingTypeLabel()}</span>
                </div>
            </div>

            <div className='billingDate'>{renderBillingDate()}</div>

            {
                isTrial &&
                <TrialNotification/>
            }
        </div>
    );
};

export default CurrentSubscription;